import React, {cloneElement} from 'react';
import {Pressable, Text, TextInput, View} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';
import {DownArrowIcon} from '../../../utils/SvgIcons';
import CommonStyles from '../../../utils/CommonStyles';

const DropdownButton = props => {
  const {
    style = {},
    inputStyle = {},
    containerStyle = {},
    hasError,
    errorText = '',
    rightIcon = <DownArrowIcon />,
    onPress,
    inputTitle = '',
    topMargin = 0,
  } = props;
  // Themed DEFAULT placeholder color (legacy grey2 → textMuted; identical in
  // light). {...props} spreads after it, so a caller's value still wins.
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      testID={tID('DropdownButton-View-Main')}
      style={[{marginTop: topMargin}, containerStyle]}
    >
      {inputTitle.length > 0 && (
        <Text
          testID={tID('DropdownButton-Text-Title')}
          style={styles.inputTitleStyle}
        >
          {inputTitle}
        </Text>
      )}
      <Pressable
        testID={tID('DropdownButton-Pressable-Input')}
        style={[styles.container(hasError), style]}
        onPress={onPress}
      >
        <TextInput
          testID={tID('DropdownButton-TextInput-1')}
          editable={false}
          placeholderTextColor={colors.textMuted}
          pointerEvents="none"
          {...props}
          style={[styles.inputContainer(hasError), inputStyle]}
        />
        {cloneElement(rightIcon, {
          testID: tID('DropdownButton-Image-RightIcon'),
          width: 10,
          height: 10,
          style: CommonStyles.ml_16,
        })}
      </Pressable>
      {hasError && errorText.length > 0 && (
        <Text
          testID={tID('DropdownButton-Text-Error')}
          style={styles.errorText}
        >
          {errorText}
        </Text>
      )}
    </View>
  );
};

export default DropdownButton;
